import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { SEARCH_SUCCESS } from "../actionTypes";
import { type PaginationData, type SearchResultData, type SearchResultRow } from "~/utils/models";
import { type TechnicalInfoData } from "~/features/search/models/SearchResultsDTO";
import { transformTechnicalInfo } from "~/features/productDetails/transformers/TechnicalInfoTransformer";

export interface ResultsState {
  results: SearchResultRow[];
  pagination: Omit<PaginationData, "currentPage">;
  firstResultProductCode: string | null;
  hasTubularResults: boolean;
  technicalInfo: TechnicalInfoData | null;
  hasCampaignResults: boolean;
}

export const resultsInitialState: ResultsState = {
  results: [],
  pagination: {
    pageSize: 0,
    numberOfPages: 0,
    totalNumberOfResults: 0,
  },
  firstResultProductCode: null,
  hasTubularResults: false,
  technicalInfo: null,
  hasCampaignResults: false,
};

/**
 * currentPage coming from SearchResultData is 1-indexed, while currentPage in searchParams slice is 0-indexed
 */
const SEARCH_RESULT_DATA_FIRST_PAGE = 1;

export const resultsSlice = createSlice({
  name: "results",
  initialState: resultsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    builder.addCase(SEARCH_SUCCESS, (state, action: PayloadAction<{ data: SearchResultData }> | any) => {
      const { data } = action.payload as { data: SearchResultData };

      if (data.pagination.currentPage === SEARCH_RESULT_DATA_FIRST_PAGE) {
        state.firstResultProductCode = data.results[0]?.productCode ?? null;
      }

      state.pagination = data.pagination;
      state.results = data.results;
      state.hasTubularResults = data.hasTubularResults;
      state.technicalInfo = transformTechnicalInfo(data.technicalInfo);
      state.hasCampaignResults = data.hasCampaignResults;
    });
  },
});

export const resultsReducer = resultsSlice.reducer;
